module.exports = __webpack_public_path__ + "static/media/back-arrow-blue.a8fdde40.svg";